export enum LastOrderTimeFrame {
  LastMonth = 'LAST_MONTH', // 0...30 days
  OneMonthBefore = 'ONE_MONTH_BEFORE', // 31...60 days
  TwoMonthsBefore = 'TWO_MONTHS_BEFORE', // 61...90 days
  AfterTwoMonthsBefore = 'AFTER_TWO_MONTHS_BEFORE', // > 90 days
}
